import { Link, useLocation } from 'react-router-dom';

interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const location = useLocation();

  return (
    <nav aria-label="面包屑导航" className="flex items-center text-sm text-foreground-500 py-3">
      <ol className="flex items-center flex-wrap gap-1">
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-400 w-4 h-4 flex items-center justify-center"></i>
            )}
            {item.href ? (
              <Link
                to={item.href}
                className="text-foreground-500 hover:text-primary-500 transition-colors duration-200"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-800 font-medium">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: items.map((item, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              name: item.label,
              item: item.href ? `https://www.hanmanhua.com${item.href}` : undefined,
            })),
          }),
        }}
      />
    </nav>
  );
}